/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

export interface AbsenceType {
    key: string;
    name: string;
    autoApprove: boolean;
}

export enum DayDefinition {
    Rolling24 = "rolling_hour_period",
    MidToMid = "calendar_day",
}

interface HoursConstraints {
    dayDefinition: DayDefinition;
    dailyHoursLimit: number;
    weeklyHoursLimit: number;
    dailyShiftsLimit: number;
    weeklyShiftsLimit: number;
    restBetweenShifts: number;
}

export interface ShiftsConfig {
    isEnabledViewingClaimableShifts: boolean;
    isEnabledClaimShift: boolean;
    isEnabledUnclaimShift: boolean;
    isEnabledRequestAbsence: boolean;
    isDisplayRatesEnabled: boolean;
    hoursConstraints: HoursConstraints;
}

export interface DriverSupport {
    supportEmail: string;
    supportPhone: string;
}
export default interface Configuration {
    timezone: string;
    absenceTypes: AbsenceType[];
    shiftsConfig: ShiftsConfig;
    driverSupport: DriverSupport;
    serviceTags: string[];
    currencyCode: string;
    driverFullName: string;
}
